import { Button, Col, Input, Row } from 'antd';
import React, { ReactElement, useState } from 'react';
import { useDispatch } from 'react-redux';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { ReactComponent as Refresh } from '../../../assets/images/svg/Refresh.svg';
import { SearchOutlined } from '@ant-design/icons';
import List from './List';
import { GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import LinkRecordsModal from '../LinkDocsWithAbha/LinkRecordsModal';
import { applyLinkedRecordsFilters, reloadLinkedRecordsList } from '../../../store/actions/linkContextAction';
import { setGetHealthIdCard, setHealthCardType } from '../../../store/actions/newAdmissionAction';
import { ID_CARD_TYPE } from '../../../shared/constants/crmConstants';

const RecordsList = (): ReactElement => {
  const [isNew, setIsNew] = useState<boolean>(false);
  const dispatch = useDispatch();

  const onSearch = (ev: any): any => {
    dispatch(applyLinkedRecordsFilters({searchFilter: ev?.target?.value}));
  };

  // enabling create abha btn
  const openIDCardModal = (cardType: string): any => {
    dispatch(setHealthCardType(cardType));
    dispatch(setGetHealthIdCard(true));
  };

  return (
    <React.Fragment>
      <PageHeader
        pageTitle="Linked Records List"
        backUrl="/abdm"
        rightComponent={(): any => (<Row gutter={GUTTOR_SPACE} justify="end" className="rightComponent mr-10">
          {/* enabled create abha button in abdm hrp module */}
          {process.env.REACT_APP_HEALTH_ID_BUTTON_ENABLED === 'true' ?
            <Col className="text-right-padding">
              <Button type="ghost"
               className="ghost-primary-btn"
                data-testid="health-id-card"
                onClick={(): any => openIDCardModal(ID_CARD_TYPE.HEALTH)}
              >
                Create ABHA
              </Button>
            </Col> : null}
          <Col className="text-right-padding">
            <Input
              onChange={onSearch}
              className="input-search"
              placeholder="Search by ABHA address/ No./ Patient ID"
              suffix={<SearchOutlined />}
            />
          </Col>
          {
            <Col className="text-right-padding">
              <Button type="primary"
              onClick={(): any => setIsNew(true)}>Link New Records</Button>
            </Col>
          }
          <Col className="refresh-button text-right-padding" onClick={(): any => dispatch(reloadLinkedRecordsList())}>
            <Refresh />
          </Col>
        </Row>)}
      />
      <List />
      {isNew && <LinkRecordsModal setVisible={setIsNew} visible={isNew} />}
    </React.Fragment>
  );
};

export default RecordsList;
